(function () {
  if (window.__globoProductGroupsCollapseInit) return;
  window.__globoProductGroupsCollapseInit = true;

  var APP_BLOCK_SELECTOR = '.mpgGeneral__block--app';
  var ROOT_SELECTOR = '.globo-product-groups-detail';
  var GROUP_SELECTOR = '.gsw-item-product-group';
  var LIST_SELECTOR = '.gsw-list-products-group';
  var ITEM_SELECTOR = '.gsw-prg-item';
  var TOGGLE_SELECTOR = '[data-globo-product-groups-toggle]';
  var COLLAPSE_AFTER = 3;

  function toArray(nodes) {
    return Array.prototype.slice.call(nodes || []);
  }

  function getItems(listElement) {
    return toArray(listElement.children).filter(function (element) {
      return element.classList && element.classList.contains('gsw-prg-item');
    });
  }

  function parsePriceText(text) {
    var value = (text || '').trim();
    if (!value) return null;

    var match = value.match(/([^0-9]*)([0-9][0-9.,]*)(.*)/);
    if (!match) return null;

    var currencyPrefix = (match[1] || '').trim();
    var numericText = (match[2] || '').trim();
    var currencySuffix = (match[3] || '').trim();

    if (!numericText) return null;

    var lastComma = numericText.lastIndexOf(',');
    var lastDot = numericText.lastIndexOf('.');
    var decimalSeparator = '';

    if (lastComma > -1 && lastDot > -1) {
      decimalSeparator = lastComma > lastDot ? ',' : '.';
    } else if (lastComma > -1) {
      decimalSeparator = numericText.length - lastComma - 1 === 2 ? ',' : '';
    } else if (lastDot > -1) {
      decimalSeparator = numericText.length - lastDot - 1 === 2 ? '.' : '';
    }

    var normalizedNumber = numericText;
    if (decimalSeparator) {
      var thousandsSeparator = decimalSeparator === '.' ? ',' : '.';
      normalizedNumber = normalizedNumber.split(thousandsSeparator).join('');
      if (decimalSeparator === ',') {
        normalizedNumber = normalizedNumber.replace(',', '.');
      }
    } else {
      normalizedNumber = normalizedNumber.replace(/[,.]/g, '');
    }

    var amount = parseFloat(normalizedNumber);
    if (!Number.isFinite(amount)) return null;

    return {
      amount: amount,
      numericText: numericText,
      currencyPrefix: currencyPrefix,
      currencySuffix: currencySuffix
    };
  }

  function formatSavingsAmount(amount, priceData) {
    if (!Number.isFinite(amount) || amount <= 0) return '';

    var formattedNumber = amount.toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });

    var currency = priceData && priceData.currencyPrefix ? priceData.currencyPrefix : '';
    if (!currency && priceData && priceData.currencySuffix) {
      currency = priceData.currencySuffix;
    }

    return 'SAVE ' + currency + formattedNumber;
  }

  function normalizeDisplayedPrice(element) {
    if (!element) return;

    var originalText = (element.textContent || '').trim();
    if (!originalText) return;

    var parsedPrice = parsePriceText(originalText);
    if (!parsedPrice) return;

    var normalizedText = parsedPrice.numericText || originalText;
    if (parsedPrice.currencyPrefix) {
      normalizedText = /[A-Za-z]$/.test(parsedPrice.currencyPrefix)
        ? parsedPrice.currencyPrefix + ' ' + normalizedText
        : parsedPrice.currencyPrefix + normalizedText;
    }

    if (normalizedText && normalizedText !== originalText) {
      element.textContent = normalizedText;
    }
  }

  function updateSaleBadge(itemElement) {
    if (!itemElement) return;

    var linkElement = itemElement.querySelector('.gsw-prg-item--link');
    var priceElement = itemElement.querySelector('.gswpg-price');
    var comparePriceElement = itemElement.querySelector('.gswpg-price-compare');
    var badgeElement = itemElement.querySelector('[data-globo-sale-badge]');
    var currentPriceText = priceElement ? priceElement.textContent : '';
    var comparePriceText = comparePriceElement ? comparePriceElement.textContent : '';

    normalizeDisplayedPrice(priceElement);
    normalizeDisplayedPrice(comparePriceElement);

    if (!linkElement || !priceElement || !comparePriceElement) {
      if (badgeElement) badgeElement.remove();
      return;
    }

    var currentPrice = parsePriceText(currentPriceText);
    var comparePrice = parsePriceText(comparePriceText);

    if (!currentPrice || !comparePrice || comparePrice.amount <= currentPrice.amount) {
      itemElement.classList.remove('has-globo-sale');
      if (badgeElement) badgeElement.remove();
      return;
    }

    var savingsText = formatSavingsAmount(comparePrice.amount - currentPrice.amount, currentPrice);
    if (!savingsText) {
      itemElement.classList.remove('has-globo-sale');
      if (badgeElement) badgeElement.remove();
      return;
    }

    itemElement.classList.add('has-globo-sale');

    if (!badgeElement) {
      badgeElement = document.createElement('span');
      badgeElement.className = 'globoProductGroupsSaleBadge';
      badgeElement.setAttribute('data-globo-sale-badge', '');
      linkElement.appendChild(badgeElement);
    }

    if (badgeElement.textContent !== savingsText) {
      badgeElement.textContent = savingsText;
    }
  }

  function updateToggleState(toggle, isExpanded) {
    if (!toggle) return;

    var expandedValue = isExpanded ? 'true' : 'false';
    if (toggle.getAttribute('aria-expanded') !== expandedValue) {
      toggle.setAttribute('aria-expanded', expandedValue);
    }

    var textElement = toggle.querySelector('.globoProductGroupsToggle__text');
    var nextText = isExpanded ? 'View Less' : 'View All';
    if (textElement && textElement.textContent !== nextText) {
      textElement.textContent = nextText;
    }
  }

  function ensureToggle(groupElement, listElement) {
    var toggle = groupElement.querySelector(TOGGLE_SELECTOR);

    if (toggle) return toggle;

    toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.className = 'globoProductGroupsToggle';
    toggle.setAttribute('data-globo-product-groups-toggle', '');
    toggle.setAttribute('aria-expanded', 'false');
    toggle.innerHTML =
      '<span class="globoProductGroupsToggle__text">View All</span>' +
      '<span class="globoProductGroupsToggle__icon" aria-hidden="true">' +
      '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">' +
      '<path d="M22.6667 13.3334L16 20L9.33335 13.3334" stroke="#0BB3FB" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
      '</svg>' +
      '</span>';

    toggle.addEventListener('click', function () {
      var isExpanded = listElement.classList.contains('is-globo-expanded');
      listElement.classList.toggle('is-globo-expanded', !isExpanded);
      listElement.classList.toggle('is-globo-collapsed', isExpanded);
      updateToggleState(toggle, !isExpanded);
    });

    listElement.insertAdjacentElement('afterend', toggle);
    return toggle;
  }

  function updateGroup(groupElement) {
    var listElement = groupElement.querySelector(LIST_SELECTOR);
    if (!listElement) return;

    var items = getItems(listElement);
    var toggle = groupElement.querySelector(TOGGLE_SELECTOR);

    items.forEach(updateSaleBadge);

    if (items.length <= COLLAPSE_AFTER) {
      listElement.classList.remove('is-globo-collapsible', 'is-globo-collapsed', 'is-globo-expanded');
      if (toggle) toggle.remove();
      return;
    }

    listElement.classList.add('is-globo-collapsible');

    if (!listElement.classList.contains('is-globo-expanded')) {
      listElement.classList.add('is-globo-collapsed');
    }

    toggle = ensureToggle(groupElement, listElement);
    updateToggleState(toggle, listElement.classList.contains('is-globo-expanded'));
  }

  function scan(root) {
    var scope = root || document;

    if (scope.matches && scope.matches('.gsw-item-product-group')) {
      updateGroup(scope);
      return;
    }

    if (scope.matches && scope.matches(ROOT_SELECTOR)) {
      bindRoot(scope);
      toArray(scope.querySelectorAll(GROUP_SELECTOR)).forEach(updateGroup);
      return;
    }

    toArray(scope.querySelectorAll(ROOT_SELECTOR)).forEach(function (rootElement) {
      bindRoot(rootElement);
      toArray(rootElement.querySelectorAll(GROUP_SELECTOR)).forEach(updateGroup);
    });
  }

  function scheduleScan(root) {
    var scope = root || document;
    if (scope.__globoProductGroupsScanScheduled) return;

    scope.__globoProductGroupsScanScheduled = true;

    window.requestAnimationFrame(function () {
      scope.__globoProductGroupsScanScheduled = false;
      scan(scope);
    });
  }

  function nodeMatchesRelevant(node) {
    if (!node || node.nodeType !== 1) return false;
    if (node.matches && node.matches(TOGGLE_SELECTOR)) return false;

    return Boolean(
      (node.matches && node.matches(ROOT_SELECTOR + ', ' + GROUP_SELECTOR + ', ' + LIST_SELECTOR + ', ' + ITEM_SELECTOR)) ||
      (node.querySelector && node.querySelector(ROOT_SELECTOR + ', ' + GROUP_SELECTOR + ', ' + LIST_SELECTOR + ', ' + ITEM_SELECTOR))
    );
  }

  function hasRelevantMutation(mutationList) {
    return mutationList.some(function (mutation) {
      if (!mutation.target || !mutation.target.closest || mutation.target.closest(TOGGLE_SELECTOR)) {
        return false;
      }

      return toArray(mutation.addedNodes).some(nodeMatchesRelevant) || toArray(mutation.removedNodes).some(nodeMatchesRelevant);
    });
  }

  function hasRootMutation(mutationList) {
    return mutationList.some(function (mutation) {
      return toArray(mutation.addedNodes).some(function (node) {
        if (!node || node.nodeType !== 1) return false;

        return Boolean(
          (node.matches && node.matches(ROOT_SELECTOR)) ||
          (node.querySelector && node.querySelector(ROOT_SELECTOR))
        );
      });
    });
  }

  function bindRoot(rootElement) {
    if (!rootElement || rootElement.__globoProductGroupsObserverBound) return;

    rootElement.__globoProductGroupsObserverBound = true;
    toArray(rootElement.querySelectorAll(GROUP_SELECTOR)).forEach(updateGroup);

    var observer = new MutationObserver(function (mutationList) {
      if (!hasRelevantMutation(mutationList)) return;
      scheduleScan(rootElement);
    });

    observer.observe(rootElement, {
      childList: true,
      subtree: true
    });

    rootElement.__globoProductGroupsObserver = observer;
  }

  function bindAppBlock(appBlock) {
    if (!appBlock || appBlock.__globoProductGroupsAppObserverBound) return;

    appBlock.__globoProductGroupsAppObserverBound = true;
    scan(appBlock);

    var observer = new MutationObserver(function (mutationList) {
      if (!hasRootMutation(mutationList)) return;
      scheduleScan(appBlock);
    });

    observer.observe(appBlock, {
      childList: true,
      subtree: true
    });

    appBlock.__globoProductGroupsAppObserver = observer;
  }

  function init() {
    toArray(document.querySelectorAll(ROOT_SELECTOR)).forEach(bindRoot);
    toArray(document.querySelectorAll(APP_BLOCK_SELECTOR)).forEach(bindAppBlock);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function () {
    init();
  });
})();
